import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";
import ExprInput from './index';
const ExprInputMeta = {
  id: 'exprInput',
  component: ExprInput,
  isFormEditor: true,
  bindings: [{
    id: 'v-model',
    prop: 'value',
    event: 'change',
    main: true,
    required: true
  }],
  fitData({
    dataSchema,
    dataPath
  }) {
    if (dataSchema.type === 'string' && dataSchema['uc:allowInterop']) {
      var _dataSchema$ui;
      const uiSettings = ((_dataSchema$ui = dataSchema.ui) === null || _dataSchema$ui === void 0 ? void 0 : _dataSchema$ui.settings) || {};
      return {
        type: 'editor',
        order: DEFAULT_EDITORS_FIT_DATA_ORDER - 0.1,
        layout: {
          type: 'exprInput',
          bindings: {
            'v-model': dataPath
          },
          props: {
            type: 'interopable-string',
            placeholder: uiSettings.placeholder || '',
            multipleLine: !!uiSettings.multipleLine
          }
        }
      };
    }
  },
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'value',
      type: 'string',
      title: '当前值'
    }, {
      id: 'type',
      type: 'string',
      title: '数据类型',
      enum: [{
        value: 'javascript',
        label: 'JavaScript 表达式'
      }, {
        value: 'interopable-string',
        label: '支持花括号插值的 字符串'
      }]
    }, {
      id: 'lazy',
      type: 'boolean',
      title: '不要频繁提交修改'
    }, {
      id: 'multipleLine',
      type: 'boolean',
      title: '多行'
    }, {
      id: 'hideIcon',
      type: 'boolean',
      title: '隐藏左侧图标'
    }, {
      id: 'placeholder',
      type: 'string'
    }]
  },
  events: [{
    id: 'change',
    name: '修改',
    desc: '数据发生修改时触发，$event 为新的值'
  }, {
    id: 'blur',
    name: '失去焦点'
  }, {
    id: 'focus',
    name: '获得焦点'
  }]
};
export default ExprInputMeta;
//# sourceMappingURL=meta.js.map
